import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=e2aef086&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"
import style0 from "./forget-password.vue?vue&type=style&index=0&lang=css&"
import style1 from "./forget-password.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports